import BaseCollectionService from "./base.collection.service";
import { ResponseWrapper } from "./response_wrapper";

class SettingService extends BaseCollectionService {
  constructor() {
    super("settings");
  }

  public async updateDefaultSettings(
    data: Record<string, any>
  ): Promise<ResponseWrapper> {
    const path = `${this.url}`;
    return await this.request(
      {
        method: "put",
        url: path,
        data
      },
      { useToken: "access" }
    );
  }

  public async getPublicMessage(): Promise<ResponseWrapper> {
    const path = `${this.url}/public-message`;
    // No `useToken`: the login page is unauthenticated and BaseService throws a
    // 401 when a token is requested but absent.
    return await this.request({
      method: "get",
      url: path
    });
  }

  public async updateInfoMessageSettings(
    data: Record<string, any>
  ): Promise<ResponseWrapper> {
    const path = `${this.url}/info-message`;
    return await this.request(
      {
        method: "put",
        url: path,
        data
      },
      { useToken: "access" }
    );
  }
}

export default new SettingService();
